/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Type_No_Dvc_SearchInputs */

const en_api_error_task_type_no_dvc_search = /** @type {(inputs: Api_Error_Task_Type_No_Dvc_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This task type does not accept DVC search details.`)
};

const pt_br2_api_error_task_type_no_dvc_search = /** @type {(inputs: Api_Error_Task_Type_No_Dvc_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este tipo de tarefa não aceita detalhes de busca DVC.`)
};

/**
* | output |
* | --- |
* | "This task type does not accept DVC search details." |
*
* @param {Api_Error_Task_Type_No_Dvc_SearchInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_type_no_dvc_search = /** @type {((inputs?: Api_Error_Task_Type_No_Dvc_SearchInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Type_No_Dvc_SearchInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_type_no_dvc_search(inputs)
	return pt_br2_api_error_task_type_no_dvc_search(inputs)
});